import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import OrderAddressItem from "../items/OrderAddressItem";
import { connect } from 'react-redux';

const styles = () => ({
});

class ResultPanel extends React.Component {
  render() {
    const { classes, orderAddresses } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.orderContainer}>
          {orderAddresses.map((orderAddress, i) => {
            return (
              <OrderAddressItem
                item={orderAddress}
                goTo={this.props.goTo}
                key={i}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

ResultPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  orderAddresses: PropTypes.array.isRequired,
  goTo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ResultPanel));



// WEBPACK FOOTER //
// ./src/components/OrderDetail/panels/ResultPanel.jsx